export default "__VITE_ASSET__85648f1b__"